import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

interface InlineSpinnerProps {
  size?: number;
  className?: string;
}

export const InlineSpinner: React.FC<InlineSpinnerProps> = ({
  size = 14,
  className = "",
}) => (
  <CircularProgress
    size={size}
    className={className}
    sx={{ color: "var(--color-fg-muted)", flexShrink: 0 }}
  />
);
